import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WellKnownRoutes } from '@core/enums';
import { UserContext } from '@core/models';
import { UserContextService } from '@core/services';
import { BtnSize, BtnType } from '@shared/enums';
import { AddressComponent, PersonalComponent } from 'app/features';
import { combineLatest, firstValueFrom, Observable, take } from 'rxjs';
import { WizardStep } from './wizard-step.interface';

@Component({
  selector: 'sp-wizard',
  templateUrl: 'wizard.component.html',
  styleUrls: ['wizard.component.scss'],
})
export class WizardComponent implements AfterViewInit {
  @ViewChild('wizardContent', { read: ViewContainerRef }) content: ViewContainerRef;
  userContext$: Observable<UserContext>;
  instance: WizardStep;

  btn = BtnType;
  size = BtnSize;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    userContextService: UserContextService
  ) {
    this.userContext$ = userContextService.userContext$;
  }

  ngAfterViewInit(): void {
    // use promise instead of observable for ng change detection
    firstValueFrom(combineLatest([this.userContext$, this.route.url]).pipe(take(1))).then(
      ([_, url]) => {
        switch (url?.[0].toString()) {
          case WellKnownRoutes.Personal:
            this.instance = this.content.createComponent(PersonalComponent).instance;
            break;
          case WellKnownRoutes.Address:
            this.instance = this.content.createComponent(AddressComponent).instance;
            break;
        }
      }
    );
  }

  onSubmit() {
    this.instance.isDirty$.pipe(take(1)).subscribe(dirty => {
      if (!dirty) {
        return this.onCancel();
      }
      if (this.instance.checkValidity()) {
        this.instance.onSubmit();
      }
    });
  }

  onCancel() {
    const cancel = this.instance.onCancel ?? (() => this.router.navigate(['profile']));
    cancel();
  }
}
